//模块功能：footer底部
export default {
    name: "foot",
    data: function () {
        return {};
    },
    mounted: function () {
    },
    methods: {}
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/iview-loader??ref--0-1!./src/sfc/foot/index.vue
// module id = null
// module chunks = 